export const getCarType = (vehicleWeightUnladen: number) => {
  if (vehicleWeightUnladen < 3500) {
    return "Car";
  }
  if (vehicleWeightUnladen > 3500 && vehicleWeightUnladen < 5000) {
    return "Box Truck";
  }
  return "Truck";
};
